import { OrderVm } from 'src/types/OrderVm';

export function hasExternalDelivery(order: OrderVm): boolean {
    return !!order.externalDelivery || !!order.externalOwnFleet || !!order.ownFleet;
}
